export const COUPON_BANNER_DISPLAYED_PAGES = [
  '/',
  '/products/[id]',
  '/large_categories/[slug]',
  '/middle_categories/[slug]',
  '/small_categories/[slug]',
  '/favorites'
];

export const COUPON_DISCOUNT_DETAIL_BUTTON = 'coupon_discount_detail_btn';
